import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useTranslate } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import CouponIcon from '@/assets/icons/coupon-icon.svg?react';
import PayoutCashIcon from '@/assets/icons/payout-cash-icon.svg?react';
import NotificationProductsIcon from '@/assets/icons/notification-products-icon.svg?react';
import OptionSelectButton from './OptionSelectButton.jsx';
import { Palette } from '@/themes/themeOverrides/Palette.js';

export default function PromotionTypeSelector() {
    const translate = useTranslate();
    const { setValue, register } = useFormContext();
    const promotionType = useWatch({ name: 'promotionType' });

    useEffect(() => {
        register('promotionType');
    }, [register]);

    const options = [
        { value: 'percent', label: translate('campaign.types.percent'), icon: <CouponIcon /> },
        { value: 'amount', label: translate('campaign.types.amount'), icon: <PayoutCashIcon /> },
        { value: 'product', label: translate('campaign.types.product'), icon: <NotificationProductsIcon /> },
    ];

    const handleSelect = value => {
        setValue('promotionType', value, { shouldDirty: true, shouldTouch: true });
    };

    return (
        <Box
            role='group'
            aria-label={translate('resources.campaign.labels.promotionType')}
            sx={{
                display: 'flex',
                borderRadius: '16px',
                backgroundColor: Palette.gray.gray75,
                overflow: 'hidden',
                border: `2px solid ${Palette.gray.gray150}`,
                width: '100%',
            }}
        >
            {options.map((opt, idx) => (
                <OptionSelectButton
                    key={opt.value}
                    label={opt.label}
                    icon={opt.icon}
                    isActive={promotionType === opt.value}
                    onClick={() => handleSelect(opt.value)}
                    showRightBorder={idx < options.length - 1}
                />
            ))}
        </Box>
    );
}
